module.exports = __webpack_public_path__ + "static/media/pipelife.6e6eae6b.svg";